import React from 'react';
import styled from 'styled-components';
import IconContainer from './IconContainer';

export default function HeaderIcons(props) {
  const { icons, affiliations } = props;
  return (
    <Container>
      <IconContainer icons={icons} affiliations={affiliations}/>
    </Container>
  );
}

const Container = styled.div`
  margin-top: 80px;
`;
